import {createSlice} from "@reduxjs/toolkit";
import {DATA_LIMIT} from "../../app/constants";

const requestDemo = createSlice({
	name: "requestDemo",
	initialState: {
		loading: false,
		error: null,
		filter:{
			page : 1,
			limit : DATA_LIMIT,
		},
		items: [],
		pagination : {
			page : 1,
			limit : DATA_LIMIT,
			totalRows: 0
		}
	},
	reducers: {
		fetchData(state) {
			state.loading = true;
			state.error = null;
			return state;
		},
		fetchDataSuccess(state, action) {
			state.loading = false;
			state.items = action.payload.data;
			if(action.payload?.pagination)
			{
				state.pagination = action.payload.pagination;
			}
			state.error = null;
			return state;
		},
		fetchDataFailed(state, action) {
			state.loading = false;
			state.error = action.payload;
			return state;
		},
		add(state, action) {
			state.items.unshift(action.payload);
			return state;
		},
		update(state, action) {
			action.payload.id = parseInt(action?.payload?.id);
			let objIndex = state.items.findIndex((item => item.id === action.payload.id));
			state.items[objIndex] = {...state.items[objIndex], ...action.payload};
			return state;
		},
		delete(state, action) {
			action.payload = parseInt(action?.payload);
			state.items = state.items.filter(function(item) {
				return item.id !== action.payload
			})
		},
		//Action search
		setFilter(state, action) {
			state.filter = action.payload;
			return state;
		},
		setFilterWithDebounce(state, action) {}
	}
})
//Action
export const requestDemoActions = requestDemo.actions;
//Reducers
export const requestDemoReducer = requestDemo.reducer;
//Selectors
export const requestDemoItemsSelector = (state) => state.requestDemo.items;
export const requestDemoLoadingSelector = (state) => state.requestDemo.loading;
export const requestDemoErrorSelector = (state) => state.requestDemo.error;
export const requestDemoFilterSelector = (state) => state.requestDemo.filter;
export const requestDemoPaginationSelector = (state) => state.requestDemo.pagination;